import axios from "axios";
import React, { useEffect, useState } from "react";
import {Link} from 'react-router-dom';

const VisaType  = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [visaTypes,setVisaTypes] = useState([]);
    useEffect(() =>{
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_TYPE;
        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => setVisaTypes(response.data))
            .catch(error => console.error("Error fetching API",error));
    },[]);


    return (
        <div className="visa-area py-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 mx-auto wow fadeInDown" data-wow-delay=".25s">
                        <div className="site-heading text-center">
                                    <span className="site-title-tagline"><i
                                        className="far fa-passport"></i> ভিসার ধরন</span>
                            <h4 className="site-title">আমাদের কাছে যেসকল কাজের ভিসা পাবেন
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="visa-wrap wow fadeInUp" data-wow-delay=".25s">

                    <div className="row gy-4">
                        {visaTypes.map((visaType, index) => {
                            return (
                                <div className="col-xl-3 col-sm-6 col-lg-4 col-6" key={index}>
                                    <Link className="text-decoration-none" to={`/visa/${visaType.slug}`}>
                                        <div className="counter-box">
                                            <div className="">
                                                <img className={'rounded-circle'} width={100} src={`${backendBaseUrl}${visaType?.image}`} alt=""/>
                                            </div>
                                            <div>
                                                <h6 className="title">{visaType?.name}</h6>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            );
                        })}
                    </div>

                </div>
            </div>
        </div>

    );
};

export default VisaType;